<template>
  <div>
    <div class="lg:mt-8 ml-8 md:mt-8 mt-4">
      <div class="lg:flex md:flex items-center lg:w-3/4 md:w-full">
        <img
          src="@/assets/images/BA3.png"
          alt="image"
          class="w-24 mx-auto lg:mb-0 md:mb-0 mb-6"
        />

        <div class="lg:ml-6 md:ml-6">
          <h1
            class="lg:font-semibold md:font-semibold font-bold lg:text-4xl md:text-3xl sm-fsize22"
          >
            Almost done, Give me a little more details about this project
          </h1>
          <p
            class="text-303030 font-medium lg:text-xl sm-fsize14 lg:mt-6 md:mt-6 mt-3"
          >
            Describe features that you need & users that will use the platform.
            This will help us create an initial setup for your ambitious
            project. Tap the mic to start narrating
          </p>
        </div>
      </div>

      <div class="lg:pl-24 md:ml-0 lg:mt-0 md:mt-0 mt-8 lg:w-5/6 md:w-full">
        <div class="mt-8">
          <div class="flex items-center">
            <div class="lg:w-1/12 md:w-1/12 w-2/12">
              <div id="speech" class="micbtn type2">
                <div class="pulse-ring" v-if="clicked"></div>
                <feather-icon
                  icon="MicIcon"
                  @click="mic"
                  class="text-primary cursor-pointer"
                  svgClasses="w-8 h-8"
                />
              </div>
            </div>

            <div>
              <p
                class="text-f8cfe9 lg:ml-8 md:ml-8 ml-8"
                :class="{
                  'sm-fsize10 fsize18': error,
                  'sm-fsize16 fsize24': !error,
                }"
              >
                {{ micStatus }}
              </p>
            </div>
          </div>
          <div class="relative p-4 mt-2">
            <textarea
              class="effect-1 w-full line-h35px fsize25 sm-fsize20 textbox-scrollbar"
              type="textarea"
              placeholder=""
              rows="6"
              cols="25"
              v-model="userRequirementsField"
            />

            <span class="focus-border"></span>
          </div>
          <span class="validate" v-if="fieldRequire"
            >Please fill the required field*</span
          >
          <span class="validate" v-if="fieldRequireCharacters"
            >Field should be greater than 25 characters*</span
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      speechRecognition: "",
      userRequirementsSpeech: "",
      userRequirementsField1: "",
      error: false,
      fieldRequire: false,
      fieldRequireCharacters: false,
      clicked: false,
      micStatus: "Tap the mic to start narrating.",
      userRequirementsField: "",
    };
  },
  methods: {
    mic() {
      this.clicked = !this.clicked;

      var SpeechRecognition =
        window.SpeechRecognition ||
        window.webkitSpeechRecognition ||
        window.mozSpeechRecognition ||
        window.oSpeechRecognition;

      if ("webkitSpeechRecognition" in window && this.clicked) {
        this.speechRecognition = new SpeechRecognition();
        // let final_transcript = "";

        this.speechRecognition.continuous = true;
        this.speechRecognition.interimResults = false;
        // this.speechRecognition.lang = document.querySelector("#select_dialect").value;
        this.speechRecognition.lang = "en-IN";

        this.speechRecognition.onstart = () => {
          // document.querySelector("#status").style.display = "block";
          this.micStatus = "Listening...";
        };
        this.speechRecognition.onerror = () => {
          // document.querySelector("#status").style.display = "none";
          this.error = true;
          this.micStatus =
            "Speech recognition doesn't support your browser. Please type your requirements.";

          this.speechRecognition.stop();
          console.log("Speech Recognition Error");
        };
        this.speechRecognition.onend = () => {
          if (this.clicked === true && !this.error) {
            this.speechRecognition.start();
          } else if (this.error) {
            this.micStatus =
              "Speech recognition doesn't support your browser. Please type your requirements.";
          } else {
            this.error = false;
            this.speechRecognition.stop();
          }

          console.log("Speech Recognition onEnded");
        };

        this.speechRecognition.onresult = (event) => {
          let interim_transcript = "";

          for (let i = event.resultIndex; i < event.results.length; ++i) {
            if (event.results[i].isFinal) {
              this.userRequirementsSpeech += event.results[i][0].transcript;
            } else {
              interim_transcript += event.results[i][0].transcript;
            }
          }
          this.userRequirementsField1 = this.userRequirementsSpeech;
          this.userRequirementsField =
            this.additionalFeature + interim_transcript;

          this.userRequirementsField = this.userRequirementsField1;
        };
        if (this.clicked === true) this.speechRecognition.start();
        if (this.clicked === false) {
          this.speechRecognition.abort();
        }
      } else {
        this.speechRecognition.stop();
        this.error = false;
        this.micStatus = "Tap the mic to start narrating";
        console.log("Speech Recognition Not Available");
      }
    },
  },
  computed: {
    ...mapState("scope", [
      "verifyFeature",
      "verifiedFeature",
      "additionalFeature",
    ]),
  },
  mounted() {
    this.$store.commit("scope/SET_CURRENT_PAGE", "speechToText");
    this.$store.commit("scope/VERIFIED_ADDITIONAL_FEATURE", false);
    this.userRequirementsField = this.additionalFeature;
  },
  watch: {
    userRequirementsField(val) {
      this.fieldRequireCharacters = false;
      if (val == "") {
        this.fieldRequire = true;
      } else {
        this.fieldRequire = false;
      }
    },
    verifyFeature(val) {
      if (val == true) {
        if (
          this.userRequirementsField &&
          this.userRequirementsField.length > 24
        ) {
          this.$store.commit("scope/VERIFIED_ADDITIONAL_FEATURE", true);
          this.$store.commit(
            "scope/SET_ADDITIONAL_FEATURE",
            this.userRequirementsField
          );
        } else {
          this.fieldRequireCharacters = true;
        }
        this.$store.commit("scope/VERIFY_ADDITIONAL_FEATURE", false);
      }
    },
  },
};
</script>
<style lang="scss">
.validate {
  color: red;
}
.input-effect {
  border: 0;
  padding: 7px 0;
  border-bottom: 3px solid #ccc;
}

.input-effect ~ .focus-border {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 4px;
  background-color: #ff92d5;
  transition: 0.4s;
}
.input-effect:focus ~ .focus-border {
  width: 100%;
  transition: 0.4s;
}
.input-effect ~ .focus-border {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 4px;
  background-color: #ff92d5;
  transition: 0.4s;
}
.input-effect:focus ~ .focus-border {
  width: 100%;
  transition: 0.4s;
}
@media (max-width: 640px) {
  .micbtn {
    width: 65px !important;
    height: auto !important;
  }
  .pulse-ring {
    width: 75px !important;
  }
  textarea {
    font: 22px/22px "Lato", Arial, sans-serif !important;
  }
}
$primary: #cd31974a;

.pulse-ring {
  content: "";

  width: 75px;
  height: 75px;
  background: $primary;
  border: 5px solid $primary;
  border-radius: 50%;
  position: absolute;
  top: -5px;
  left: -5px;
  animation: pulsate infinite 1.5s;
}
@keyframes pulsate {
  0% {
    transform: scale(1, 1);
    opacity: 1;
  }
  100% {
    transform: scale(1.3, 1.3);
    opacity: 0;
  }
}

.type2 .pulse-ring {
  background: transparent;
}
.micbtn {
  border: none;
  padding: 0;
  border-radius: 100%;
  width: 65px;
  height: 65px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  padding: 0;
  margin: 0;
  background: red;
  position: relative;
  z-index: 999;
  display: inline-block;
  font-size: 3rem;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-image: none;
}
.type2 {
  background: $primary;
}
</style>
